// React
import React from 'react';
// External
import { withRouter } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
// Internal
import NavbarPrimary from 'components/shared/organisms/NavbarPrimary/NavbarPrimary';
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';
// Style
import './styles.scss';

function EngravingThankYou() {
    return (
        <div className="main-container">
            <NavbarPrimary hideNav />
            <div className="body-content">
                <PageTitle title="Engraving Approval" />

                <ContentCard
                    className="mt-62"
                    headerTitle="Thank you"
                    divider={false}
                >
                    <Container fluid className="engraving-container" style={{ display: 'table-cell' }}>
                        <Row>
                            <Col lg={12} className="col-12">
                                <p>
                                    Thank you for your submission. Your final artwork has been submitted to Lawnswood
                                    for engraving.
                                </p>
                            </Col>
                        </Row>
                    </Container>
                </ContentCard>
            </div>
        </div>
    );
}

export default withRouter(EngravingThankYou);
